import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { LoadingButton } from '@mui/lab';
import { Box, Button, CardContent, DialogTitle, ListItemIcon, Paper } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonHelper } from 'src/utils/commonHelper';

const PinterestAuthorizationModal = (props) => {
  const { t: translate } = useTranslation();
  const [isLoadingOn, setLoadingOn] = useState(false);
  const isCustomDomain = CommonHelper.CustomDomain();
   const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage("is_portal_admin");

  const handleConnectPinterest = () => {
    setLoadingOn(true);
    props.handleConnectPinterest();
  };

  const handleClose = () => {
    props.handleClose();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open>
      <DialogTitle id="customized-dialog-title">
        <Typography gutterBottom variant="h4">
          {props.reAuth
            ? translate('integration.pinterest.reauthenticate_pinterest')
            : translate('integration.pinterest.converted_your_pinterest_account') + '?'}
        </Typography>
        {(!isCustomDomain || isPortalAdmin) && (
          <Box display="flex" justifyContent="center" alignItems="center">
            <Button
              variant="outlined"
              startIcon={<YouTubeIcon />}
              onClick={() => window.open('https://www.youtube.com/watch?v=qV9XlIJbV6g', '_blank')}
              color="primary"
            >
              {translate('common.tutorial')}
            </Button>
          </Box>
        )}
      </DialogTitle>
      <DialogContent dividers>
        <CardContent sx={{ p: { xs: 0, md: 0 }, color: 'grey.800' }}>
          <Typography variant="body1" sx={{ mx: 'auto', fontWeight: 'bold' }}>
            {props.reAuth
              ? `${translate('common.verify_these_requirements')}`
              : `${translate('common.make_sure_completed_steps')}`}
          </Typography>

          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1, mt: 2 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {props.reAuth
                ? `${translate('integration.pinterest.confirm_orginal_login')}`
                : `${translate('integration.pinterest.ensure_signed_in')}`}
            </Typography>
          </Paper>

          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {props.reAuth
                ? `${translate('integration.pinterest.verify_pinterest_account')}`
                : `${translate('integration.pinterest.confirm_pinterest_account')}`}
            </Typography>
          </Paper>

          {!props.reAuth && (
            <>
              <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                <ListItemIcon>
                  <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
                </ListItemIcon>
                <Typography variant="body1">
                  {translate('integration.pinterest.data_privacy_security_standards')}
                </Typography>
              </Paper>

              <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                <ListItemIcon>
                  <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
                </ListItemIcon>
                <Typography variant="body1">{translate('integration.pinterest.copyright_and_privacy')}</Typography>
              </Paper>
            </>
          )}

          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {props.reAuth
                ? `${translate('integration.pinterest.valid_account_permission')}`
                : `${translate('integration.pinterest.maintain_valid_permission')}`}
            </Typography>
          </Paper>
        </CardContent>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          {translate('common.close')}
        </Button>
        <LoadingButton
          variant="contained"
          loading={isLoadingOn}
          autoFocus
          onClick={() => {
            handleConnectPinterest();
          }}
        >
          {props.reAuth ? translate('common.reconnect') : translate('common.connect')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default PinterestAuthorizationModal;
